import { Stack, Typography } from '@mui/material';
import { ImageWithFallback } from '@qb/frontend/components/ImageWithFallback';
import { clampLinesSx } from '@qb/frontend/utils/clampLinesSx';
import { TenantConfig } from '@/shared/types/controllers/sps/SPSAppControllerTypes';
import { PartDisplayDataResponse } from '@/shared/types/controllers/sps/SPSPartControllerTypes';
type TrustBoxPriceDetailsDesktopTrustBoxNavbarProps = {
  tenantConfig: TenantConfig;
  part: PartDisplayDataResponse['part'];
  quantityInput: React.ReactNode;
  ctaButtons: React.ReactNode;
};
export const TrustBoxPriceDetailsDesktopTrustBoxNavbar = ({
  tenantConfig,
  part,
  quantityInput,
  ctaButtons
}: TrustBoxPriceDetailsDesktopTrustBoxNavbarProps) => {
  return <Stack direction="row" sx={{
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: {
      xs: 2,
      xl: 5
    },
    width: '100%'
  }} data-sentry-element="Stack" data-sentry-component="TrustBoxPriceDetailsDesktopTrustBoxNavbar" data-sentry-source-file="TrustBoxPriceDetailsDesktopTrustBoxNavbar.tsx">
      <Stack direction="row" spacing={3} sx={{
      width: {
        lg: '40%',
        xl: '50%'
      },
      mr: 'auto'
    }} data-sentry-element="Stack" data-sentry-source-file="TrustBoxPriceDetailsDesktopTrustBoxNavbar.tsx">
        <ImageWithFallback tenantAlias={tenantConfig.tenantAlias} src={part.images[0]?.target} width={50} height={50} alt={`${part.partNumber} on ${tenantConfig.companyName}`} data-sentry-element="ImageWithFallback" data-sentry-source-file="TrustBoxPriceDetailsDesktopTrustBoxNavbar.tsx" />
        <Stack direction="column" sx={{
        width: '100%'
      }} data-sentry-element="Stack" data-sentry-source-file="TrustBoxPriceDetailsDesktopTrustBoxNavbar.tsx">
          <Typography variant="h4" data-sentry-element="Typography" data-sentry-source-file="TrustBoxPriceDetailsDesktopTrustBoxNavbar.tsx">
            {part.partNumber} {part.manufacturer.name}
          </Typography>
          <Typography variant="paragraph" sx={{
          height: 21,
          ...clampLinesSx(1)
        }} data-sentry-element="Typography" data-sentry-source-file="TrustBoxPriceDetailsDesktopTrustBoxNavbar.tsx">
            {part.description}
          </Typography>
        </Stack>
      </Stack>
      <Stack direction="row" sx={{
      alignItems: 'center',
      gap: 1
    }} data-sentry-element="Stack" data-sentry-source-file="TrustBoxPriceDetailsDesktopTrustBoxNavbar.tsx">
        {quantityInput}
      </Stack>
      <Stack data-cy="ctaButtons-wrapper" direction="row" sx={{
      flexWrap: 'wrap-reverse',
      alignItems: 'center',
      justifyContent: 'end',
      columnGap: 2,
      rowGap: 1,
      ml: 2,
      maxWidth: 328,
      '& * ': {
        m: 0
      },
      '& p ': {
        m: 0
      },
      '& button ': {
        m: 0,
        width: 156
      },
      '& .CallToActionRequestQuote-secondaryMessage': {
        display: 'none'
      },
      '& .MuiStack-root': {
        display: 'contents'
      }
    }} data-sentry-element="Stack" data-sentry-source-file="TrustBoxPriceDetailsDesktopTrustBoxNavbar.tsx">
        {ctaButtons}
      </Stack>
    </Stack>;
};